<template>
    <div>
        <div style="background:#fff;text-align: right;margin: 15px 0"></div>
        <el-table
                border
                :data="tableList"
                ref="table"
                :row-class-name="tableRowClassName"
                :header-cell-style="{
                            'background-color': '#EFF3F6',
                            'font-size': '14px',
                            'color': '#000000',
                    }"
                :row-key="getRowKeys"
                :expand-row-keys="expands">
            <el-table-column
                    type="index"
                    label="序号"
                    align="center"
                    width="50">
                <template scope="scope">
                    <span>{{(currentPage - 1) * pageSize + scope.$index + 1}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="fileNum"
                    align="center"
                    label="处理文件文号">
                <template scope="scope">
                    <p>{{scope.row.fileNum || "--"}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="awardDept"
                    align="center"
                    label="实施/认定部门">
                <template scope="scope">
                    <p>{{scope.row.awardDept || "--"}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="prizeTypeName"
                    label="奖励类型"
                    align="center">
                <template scope="scope">
                    <p>{{scope.row.prizeTypeName || "--"}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="content"
                    align="center"
                    label="奖励内容">
                <template scope="scope">
                    <p>{{scope.row.content || "--"}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="publishTime"
                    label="奖励时间"
                    align="center">
                <template scope="scope">
                    <p>{{scope.row.publishTime | dateStrIntercept}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="remark"
                    label="奖励事由"
                    align="center">
                <template scope="scope">
                    <p>{{scope.row.remark | dateStrIntercept}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="comeFrom"
                    align="center"
                    label="数据来源">
            </el-table-column>
            <el-table-column
                    prop="state"
                    align="center"
                    label="数据状态">
                <template scope="scope">
                    <p type="text" v-if="scope.row.state == 1" class="change-examine"><i
                            class="examine-effective"></i><span>有效</span></p>
                    <p type="text" v-else-if="scope.row.state == 2" class="change-examine"><i
                            class="examine-waitSubmit"></i><span>待生效</span></p>
                    <p type="text" v-else-if="scope.row.state == 3" class="change-examine"><i
                            class="examine-invalid"></i><span>已作废</span></p>
                    <p type="text" v-else-if="scope.row.state == 4" class="change-examine"><i
                            class="examine-waitSubmit"></i><span>待提交</span></p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="createTime"
                    label="登记时间"
                    align="center">
                <template scope="scope">
                    <p>{{scope.row.createTime | dateStrIntercept}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="cancelTime"
                    label="作废日期"
                    align="center">
                <template scope="scope">
                    <p>{{scope.row.cancelTime && scope.row.cancelTime.substring(0,11)}}</p>
                </template>
            </el-table-column>
            <el-table-column
                    prop="date"
                    label="操作"
                    align="center"
                    width="150px">
                <template slot-scope="scope">
                    <el-button type="text" @click="toogleExpand(scope.row)">查看</el-button>
                </template>
            </el-table-column>
            <el-table-column type="expand" width="1">
                <template slot-scope="props">
                    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="160px" style="position: relative" inline>
                        <el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="处理文件文号 : " prop="fileNum" size="small">
                                        <span>{{props.row.fileNum}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="实施/认定部门 : " prop="awardDept" size="small">
                                        <span>{{props.row.awardDept}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="奖励类型 : " prop="prizeType" size="small">
                                        <span>{{props.row.prizeTypeName}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="8">
                                    <el-form-item label="奖励内容 : " prop="content" size="small">
                                        <span>{{props.row.content}}</span>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="8">
                                    <el-form-item label="奖励时间 : " prop="publishTime" size="small">
                                        <span>{{props.row.publishTime | dateStrIntercept}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-form-item label="奖励事由 : " prop="remark" size="small">
                                        <span>{{props.row.remark}}</span>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col>
                                    <el-form-item label="相关文件文号附件 : " prop="fileList">
                                        <docUploadView
                                                v-for="(item,index) in props.row.attachmentParamList"
                                                :key="index" :type="type" :index="index"
                                                :docItem="item"
                                        />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-row>
                    </el-form>
                    <span @click="toogleExpand(props.row)"
                          style="position: absolute; bottom: 16px; right: 17px; font-weight: 400; color: #1890FF; font-size: 14px; cursor: pointer;">
                                    收起<i class="el-icon-arrow-up" style="color: #1890FF;margin-left: 4px;"></i>
                                </span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-size="pageSize"
                layout="total, prev, pager, next"
                :total="total">
        </el-pagination>
    </div>
</template>
<script>
    import {mapState} from "vuex";

    export default {
        name: "reward-information",
        data() {
            return {
                id:'',
                dataId:'',
                changeData:{},
                getRowKeys(row) {
                    return row.id
                },
                // 要展开的行，数值的元素是row的key值
                expands: [],
                ruleForm: {
                    fileNum: '',
                    awardDept: '',
                    prizeType: '',
                    content: '',
                    publishTime: '',
                    remark: '',
                    attachmentParamList: [{//附件列表
                        Id: "",
                        citeId: "",
                        name: "",
                        fileType: 1,
                        filePath: "",
                        required: false,
                        attributes: {
                            attname: "",
                            delmethod: "2",
                            allows: '.pdf,.PDF'
                        }
                    }],
                    fileList: [],//附件类型上传校验
                },
                currentPage: 1,
                pageSize: 10,
                total: 0,
                type: 'ent_base_info',
                rules: {
                    fileNum: [
                        {required: true, message: '请输入处理文件文号', trigger: 'blur'},
                    ],
                    awardDept: [
                        {required: true, message: '请输入实施/认定部门', trigger: 'blur'},
                    ],
                    prizeType: [
                        {required: true, message: '请选择奖励类型', trigger: 'change'},
                    ],
                    content: [
                        {required: true, message: '请输入奖励内容', trigger: 'blur'},
                    ],
                    publishTime: [
                        {required: true, message: '请选择奖励时间', trigger: 'change'},
                    ],
                    remark: [
                        {required: true, message: '请选输入奖励事由', trigger: 'blur'},
                    ],
                    fileList: [
                        {required: true, message: '请上传相关文件文号附件', trigger: 'change'},
                    ]
                },
                tableList: [],
                queryParameter: {
                    attachmentParamList: [],
                    id: '',
                    entId: '',
                    entRoleCode: '',
                    prizeName: '',
                    prizeType: '',
                    prizeProjectName: '',
                    headName: '',
                    awardDept: '',
                    publishTime: '',
                    state: '',
                    remark: '',
                    delFlag: '',
                    createUser: '',
                    createTime: '',
                    updateUser: '',
                    updateTime: '',
                    content: '',
                    cancelFlag: '',
                    cancelTime: '',
                    fileNum: '',
                    comeFrom: '',
                }
            }
        },
        computed: {
            ...mapState({
                enterpriseRewardTypeList: (state) => state.dataDictionary.enterpriseRewardTypeList,
            })
        },
        created() {
            this.getRouterQuery();
            this.getChangeInfo();
            this.querData();
            this.$store.dispatch('dataDictionary/getEnterpriseRewardTypeList');//获取奖励类型
        },
        activated() {
            this.getRouterQuery();
            this.getChangeInfo();
            this.querData();
            this.$store.dispatch('dataDictionary/getEnterpriseRewardTypeList');//获取奖励类型
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                for (let i in this.changeData){
                    if(row.id == i && this.changeData[i] == 1){
                        return 'newData-row';
                    }else if(row.id == i && this.changeData[i] == 2){
                        return 'cancel-row';
                    }else {
                        return ''
                    }
                }
            },
            getChangeInfo(){
                this.$http.get(`/change/field-record/module-item?changeRecordId=${this.dataId}&changeModule=prize`).then((res)=>{
                    if(res.data.data && res.data.data.length>0){
                        this.changeData =res.data.data[0].changeFields
                    }
                })
            },
            getRouterQuery(){
                this.id = this.$route.params.changeId;
                this.dataId = this.$route.params.id;
            },
            // 获取数据
            querData() {
                this.$http.post('/change/hentprize/list', {
                    page: this.currentPage,
                    rows: this.pageSize,
                    filter: {
                        entId: this.id
                    },
                    searchKey: '',
                    orderBy: 'create_time desc'
                }).then((res) => {
                    if (res.data) {
                        this.tableList = res.data.rows;
                        this.total = res.data.total;
                        if (this.tableList.length && this.tableList[0].state == 4) {
                            this.expands.push(this.tableList[0].id)
                        }
                    }
                })
            },
            // 新增
            saveData() {
                this.ruleForm. attachmentParamList= [{//附件列表
                    Id: "",
                    citeId: "",
                    name: "",
                    fileType: 1,
                    filePath: "",
                    required: false,
                    attributes: {
                        attname: "",
                        delmethod: "2",
                        allows: '.pdf,.PDF'
                    }
                }];
                for (let key in this.queryParameter) {
                    if (key == 'attachmentParamList') {
                        this.queryParameter[key] = []
                    } else {
                        this.queryParameter[key] = ''
                    }
                }
                if (this.tableList.length && this.tableList[0].state == 4) {
                    return
                } else {
                    this.queryParameter.entId = this.id;
                    this.queryParameter.state = 4;
                    this.$http.post('/change/hentprize/save', this.queryParameter).then((res) => {
                    });
                    this.querData();
                }
            },
            // 删除/取消
            deleteData(row,formName) {
                this.$http.post('/change/hentprize/delete?id=' + row.id).then((res) => {
                });
                this.querData();
                this.$refs[formName].resetFields();
            },
            // 查看
            toogleExpand(row) {
                this.$refs.table.toggleRowExpansion(row)
            },
            // 作废
            voidData(row) {
                this.$http.post('/change/hentprize/cancel?id=' + row.id).then((res) => {
                });
                this.querData();
            },
            // 保存
            preservation(row, formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.queryParameter.entId = this.id;
                        this.queryParameter.state = row.state;
                        this.queryParameter.id = row.id;
                        this.queryParameter.fileNum = this.ruleForm.fileNum;
                        this.queryParameter.awardDept = this.ruleForm.awardDept;
                        this.queryParameter.prizeType = this.ruleForm.prizeType;
                        this.queryParameter.content = this.ruleForm.content;
                        this.queryParameter.publishTime = this.ruleForm.publishTime;
                        this.queryParameter.remark = this.ruleForm.remark;
                        this.queryParameter.attachmentParamList = this.ruleForm.attachmentParamList;
                        this.$http.post('/change/hentprize/save', this.queryParameter).then((res) => {
                        });
                        this.querData();
                        this.$refs[formName].resetFields();
                    } else {
                        return false;
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSize = val;
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.querData();
            }
        },
        filters: {
            dateStrIntercept(str) {
                if (str) {
                    return str.substring(0, 11);
                } else {
                    return '--'
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    /deep/ .el-textarea__inner {
        width: 690px;
        height: 80px;
    }

    .card-content-search-add {
        width: 82px;
        height: 32px;
        background: #1890FF;
        border: none;
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
        line-height: 32px;
        margin-left: 12px;
    }

    .card-content-search-add-able {
        width: 82px;
        height: 32px;
        background: #1890FF;
        border: none;
        border-radius: 2px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
        line-height: 32px;
        margin-left: 12px;
        opacity: 25%;
    }

</style>